import "/acf-blocks/block-districts/block-districts.scss"

class BlockDistricts {
  constructor() {
    this.blocks = document.querySelectorAll('.js-block-districts')
    this.init()
  }

  init() {
    if (!this.blocks.length) return
    
    this.blocks.forEach(block => {
      const accordion = block.querySelector('.js-districts-accordion')
      const tabs = block.querySelectorAll('.js-accordion-tab')
      const images = block.querySelectorAll('.block-districts__image')
      
      if (!accordion || !tabs.length || !images.length) return
      
      // Watch for class changes on tabs to switch images
      tabs.forEach((tab, index) => {
        // Create observer to watch for class changes
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              // If this tab becomes active, switch to its corresponding image
              if (tab.classList.contains('is-active')) {
                this.switchImage(images, index)
              }
            }
          })
        })
        
        // Start observing the tab for class attribute changes
        observer.observe(tab, {
          attributes: true,
          attributeFilter: ['class']
        })
      })
    })
  }

  switchImage(images, activeIndex) {
    // Remove active class from all images
    images.forEach(image => {
      image.classList.remove('is-active')
    })
    
    // Add active class to the clicked image
    if (images[activeIndex]) {
      images[activeIndex].classList.add('is-active')
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BlockDistricts()
})